module.exports = __webpack_public_path__ + "img/DAB-Profile-Alexander.954944ea.png";